import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta": "/sistema/facturacion", "documento": "invoices", "acceso": "sesion", "filas": ["026", "020", "027", "028"], "cita": "prod:Areas/Invoices/Controllers/DashboardController.cs:34"} satisfies RutaProd;
